import { createNoAuthenticationClient, createClient } from "@/http-client";
import {AxiosInstance, AxiosResponse} from "axios";
import { CandidateProfile } from "@/models/CandidateProfile";
import { WizardProgress } from "@/models/WizardProgress";
import { prefixBaseUrlOneApi } from "@/helper";

export class CandidateService {
    private client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    async isRegistered(): Promise<boolean | null> {
        const response = await this.client.get<boolean | null>(
            prefixBaseUrlOneApi + "/kandidaten/candidate/isregistered"
        );
        return response.status == 200 ? response.data : null;
    }

    async isPublished(): Promise<boolean> {
        const response = await this.client.get<boolean>(
            prefixBaseUrlOneApi + "/kandidaten/candidate/ispublished"
        );
        return response.status == 200 ? response.data : false;
    }

    async getWizardStep(): Promise<number | null> {
        const response = await this.client.get(
            prefixBaseUrlOneApi + "/kandidaten/candidate/wizardStep"
        );
        return response.status == 200 ? response.data : null;
    }

    async get(): Promise<CandidateProfile | null> {
        const response = await this.client.get<CandidateProfile>(
            prefixBaseUrlOneApi + "/kandidaten/candidate"
        );
        return response.status == 200 ? response.data : null;
    }

    async getId(): Promise<number | null> {
        const response = await this.client.get<number>(
            prefixBaseUrlOneApi + "/kandidaten/candidate/id"
        );
        return response.status == 200 ? response.data : null;
    }

    async getEmail(): Promise<string | null> {
        const response = await this.client.get<string>(
            prefixBaseUrlOneApi + "/kandidaten/candidate/email"
        );
        return response.status == 200 ? response.data : null;
    }

    async getContactFormData(): Promise<[] | null> {
        const response = await this.client.get<[]>(
            prefixBaseUrlOneApi + "/kandidaten/candidate/contact"
        );
        return response.status == 200 ? response.data : null;
    }

    async getRegCandidate(): Promise<CandidateProfile | null> {
        const response = await this.client.get<CandidateProfile>(
            prefixBaseUrlOneApi + "/kandidaten/candidate/registration"
        );
        return response.status == 200 ? response.data : null;
    }

    async register(profile: CandidateProfile): Promise<boolean> {
        const response = await this.client.post(
            prefixBaseUrlOneApi + `/kandidaten/candidate`,
            profile
        );
        return response.status == 200;
    }

    //async emailVerified(email: string): Promise<boolean> {
    //    const response = await this.client.put(`/api/candidate/verified?email=` + email);
    //    return response.status == 200;
    //}

    async updateCandidate(profile: CandidateProfile): Promise<boolean> {
        const response = await this.client.post(
            prefixBaseUrlOneApi + `/kandidaten/candidate/wizardData`,
            profile
        );
        return response.status == 200;
    }

    async updated(id: number): Promise<AxiosResponse> {
        return await this.client.post(
            prefixBaseUrlOneApi + "/candidate/updated/" + id
        );
    }

    async generateMailForInternalStatus(encryptedId: string): Promise<boolean> {
        console.log(encryptedId);

        const response = await this.client.post(
            prefixBaseUrlOneApi +
                "/kandidaten/candidate/generateMailForInternalStatus",
            {
                encryptedId: encryptedId,
            }
        );
        return response.status === 200;
    }

    async putCandidatePause(
        encryptedId: string,
        reason: string
    ): Promise<boolean> {
        return await this.client.put(
            prefixBaseUrlOneApi + "/candidate/pauseWithEncryptedId/",
            {
                encryptedId: encryptedId,
                deactivationReason: reason,
            }
        );
    }

    async putCandidateRenew(encryptedId): Promise<boolean> {
        return await this.client.put(
            prefixBaseUrlOneApi + "/candidate/renewWithEncryptedId/",
            {
                encryptedId: encryptedId,
            }
        );
    }

    async setProgressStep(wizardProgress: WizardProgress): Promise<boolean> {
        const response = await this.client.post(
            prefixBaseUrlOneApi + `/kandidaten/candidate/wizardStep`,
            wizardProgress
        );
        return response.status === 200;
    }

    async triggerVerificationMail(): Promise<boolean> {
        const response = await this.client.post(
            prefixBaseUrlOneApi + `/kandidaten/candidate/verify`
        );
        return response.status === 200;
    }
}

export async function createCandidateService(app): Promise<CandidateService> {
    const isAuthenticated =
        app.appContext.config.globalProperties.$auth.isAuthenticated.value;
    if (!isAuthenticated)
        console.warn(
            "Creating a non-authenticated client for CandidateService"
        );
    const client = isAuthenticated
        ? await createClient(app)
        : await createNoAuthenticationClient();
    return new CandidateService(client);
}
